export default {
      id: "overview-icon-usage",
      viewBox: "0 0 28 22",
      url: __webpack_public_path__ + "sprite.svg#overview-icon",
      toString: function () {
        return this.url;
      }
    }